package gr.tech.pdfgenerator.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY
import gr.tech.pdfgenerator.util.CONSTANTS.FONT_FAMILY2
import org.jetbrains.compose.web.css.*

val InputLabelStyle = CssStyle {
    base {
        Modifier
            .fontFamily(FONT_FAMILY)
            .fontSize(1.cssRem)
            .margin(bottom = 2.px)
    }
}

val stringInputStyle = CssStyle {
    base {
        Modifier
            .fontFamily(FONT_FAMILY)
            .fontSize(0.875.cssRem)
            .padding(4.px)
            .fillMaxWidth()
    }
    focus {
        Modifier
            .transition(Transition.all(150.ms))
            .outline(2.px, LineStyle.Solid, Theme.MediumGreen.rgb)
    }
}

val PropDerivativeLabelStyle = CssStyle {
    base {
        Modifier
            .margin(0.px)
            .fontFamily(FONT_FAMILY)
            .fontSize(1.10.cssRem)
            .fontWeight(FontWeight.Bold)
    }
}

val PropDerivativeSpanStyle = CssStyle {
    base {
        Modifier
            .margin(left = 16.px)
            .fontFamily(FONT_FAMILY2)
            .fontSize(1.10.cssRem)
            .fontWeight(FontWeight.Light)
    }
}

